import getApiInstance from 'data/common/ApiCallGenerique';
import Translator from 'translator';
import { Logger, Toastr } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getUsers() {
    return dispatch => {
        return apiCaller
            .call(api.getAllUsers())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHEPOOL__SET_USERS',
                        users: data.users
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolUsers - ', error);
                throw error;
            });
    };
}
function getUserDetails(userId) {
    return dispatch => {
        return apiCaller
            .call(api.getUserDetails(userId))
            .then(({ data }) => {
                if (data.userDetails)
                    dispatch({
                        type: 'FHEPOOL__FHEPRODUCT_SET_USER',
                        userDetails: data.userDetails,
                        userId: userId
                    });

                if (data.userSDM17SPG)
                    dispatch({
                        type: 'FHEPOOL__FHEPRODUCT_UPDATE_SDM17SPGS',
                        SDM17SPGs: data.userSDM17SPG
                    });

                if (data.userSDM17DEC)
                    dispatch({
                        type: 'FHEPOOL__FHEPRODUCT_UPDATE_SDM17DECS',
                        SDM17DECs: data.userSDM17DEC
                    });

                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolUserDetails - ', error);
                throw error;
            });
    };
}
function updateUserDetails(userId, userForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateUserDetails(userId, userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHEPOOL__USER_UPDATE_DETAILS',
                        userId: data.user._id,
                        userDetails: data.user
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolUserDetails - ', error);
                throw error;
            });
    };
}
function addUser(userForm) {
    return dispatch => {
        return apiCaller
            .call(api.addUser(userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHEPOOL__ADD_USER',
                        userId: data.user._id,
                        userDetails: data.user
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: setFHEPoolAddUser - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.${data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message}`,
                                'api.message.default'
                            ),
                            Translator.translate('api.message.intermediate_error')
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolAddUser - ', error);
                throw error;
            });
    };
}
function resetPassword(userId) {
    return () => {
        return apiCaller
            .call(api.resetPassword(userId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolResetPassword - ', error);
                throw error;
            });
    };
}

export { getUsers, getUserDetails, updateUserDetails, addUser, resetPassword };



// WEBPACK FOOTER //
// ./environments/fhepool/data/Users/actions.js